import { PlusOutlined } from '@ant-design/icons';
import { Input, InputRef, Tag } from 'antd';
import { editUmsMemberTags } from 'apis/ums';
import i18n from 'i18n';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useToggle } from 'react-use';

const UmsMemberTagEditor = ({
  tags: initialTags,
  memberId,
}: {
  tags: string[];
  memberId: number;
}) => {
  const [tags, setTags] = useState(initialTags);
  const [inputVisible, toggleInputVisible] = useToggle(false);
  const inputRef = useRef<InputRef>(null);
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = useCallback(async () => {
    if (inputValue && !tags.includes(inputValue)) {
      const newTags = [...tags, inputValue];
      await editUmsMemberTags({ id: memberId, tags: newTags });
      setTags(newTags);
      toggleInputVisible(false);
      setInputValue('');
    } else {
      toggleInputVisible(false);
    }
  }, [inputValue, tags, memberId, toggleInputVisible]);

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  return (
    <div className="flex flex-wrap gap-2">
      {tags.length
        ? tags.map((tag) => (
            <Tag
              className="m-0"
              key={tag}
              closable
              onClose={async () => {
                const newTags = tags.filter((t) => t !== tag);
                await editUmsMemberTags({ id: memberId, tags: newTags });
                setTags(newTags);
              }}
            >
              {tag}
            </Tag>
          ))
        : null}
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={{ width: 78 }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputConfirm}
          onPressEnter={handleInputConfirm}
        />
      ) : (
        <Tag onClick={toggleInputVisible}>
          <PlusOutlined /> {i18n.t('new_tag')}
        </Tag>
      )}
    </div>
  );
};

export default UmsMemberTagEditor;
